import { render, staticRenderFns } from "./BasePopupEditor.vue?vue&type=template&id=95aa8e88&scoped=true&"
import script from "./BasePopupEditor.vue?vue&type=script&lang=js&"
export * from "./BasePopupEditor.vue?vue&type=script&lang=js&"
import style0 from "./BasePopupEditor.vue?vue&type=style&index=0&id=95aa8e88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95aa8e88",
  null
  
)

export default component.exports